import { defaultColumns, defaultSort } from '../../components/ntax/partners/columns';

export default {
  state: {
    ntaxPartners: [],
    loading: false,
    tableConfig: null,
    sorting: {
      prop: 'company.name',
      order: 'ascending',
    },
  },
  getters: {
    ntaxPartners: state => state.ntaxPartners,
    loading: state => state.loading,
    tableConfig: state => state.tableConfig,
    sorting: state => state.sorting,
    filterString: state => state.filterString,
    currentPage: state => state.currentPage,
  },
  mutations: {
    setNtaxPartners(state, ntaxPartners) {
      state.ntaxPartners = ntaxPartners;
    },
    setLoading(state, display) {
      state.loading = display;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage;
    },
  },
  actions: {
    async fetchTableConfig({ commit }) {
      try {
        const setting = await axios.get('api/table-settings/ntax-partner-list');
        if (setting.id) {
          const tableConfig = {
            id: setting.id,
            type: 'ntax-partner-list',
            columns: JSON.parse(setting.config).columns,
            sort: JSON.parse(setting.config).sort,
          };
          commit('setTableConfig', tableConfig);
        } else {
          const tableConfig = {
            type: 'ntax-partner-list',
            columns: defaultColumns,
            sort: defaultSort,
          };
          commit('setTableConfig', tableConfig);
        }
      } catch (e) {
      }
    },
    async fetchAll({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setCurrentPage', 1);
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const query = `?page=${state.currentPage}&sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&${state.filterString}`;
        const ntaxPartners = await axios.get('api/ntax-partners' + (query || ''));
        commit('setNtaxPartners', ntaxPartners);
      } catch (e) {
        console.log(e);
      }
      commit('setLoading', false);
    },

    async fetch({ commit }, id) {
      try {
        return await axios.get('api/ntax-partners/' + id);
      } catch (e) {
      }
    },

    async update({ commit }, payLoad) {
      await axios.put('api/ntax-partners', payLoad);
    },
  },
};
